export default "__VITE_ASSET__533ce500__"